export const lsModalProfileFilterValStr = "modal_profile_table_filter_obj";
